import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

// Get all the carousel-articles elements on the page
const carousels = document.querySelectorAll('.carousel-articles');

carousels.forEach((carouselElement, index) => {
    // Add a unique class to the carousel and its swiper element
    const swiperContainer = carouselElement.querySelector('.swiper');
    swiperContainer.classList.add(`swiper-${index}`);

    const prevButton = carouselElement.querySelector('.swiper-button-prev');
    const nextButton = carouselElement.querySelector('.swiper-button-next');

    // Add unique class to the navigation buttons
    prevButton.classList.add(`swiper-prev-${index}`);
    nextButton.classList.add(`swiper-next-${index}`);

    // Initialize Swiper for each carousel
    const swiper = new Swiper(`.swiper-${index}`, {
        modules: [Navigation, Pagination],
        a11y: true,
        speed: 400,
        loop: false,
        grabCursor: true,
        draggable: true,
        centeredSlides: false,
        slidesPerView: 1.25,
        spaceBetween: 30,
        breakpoints: {
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 30
            },
            992: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 30
            }
        },
        slideClass: 'swiper-slide',
        navigation: {
            nextEl: `.swiper-next-${index}`, // Scoped next button
            prevEl: `.swiper-prev-${index}`, // Scoped previous button
        },
    });
});
